import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts } from '@/utils/preset'
import { rem } from '@/utils/helpers'
import Form from '@/components/common/Form'
import Typography from '@/components/common/Typography'

const Template = props => {
  const { file, title, ...other } = props
  return (
    <StaticQuery
      query={query}
      render={data => {
        const form = {
          ...data.forms.edges[0].node
        }
        const inputFields = [
          ...data.forms.edges[0].node.inputFields
        ]
        form.inputFields = inputFields
        return (
          <Root {...other}>
            <Head>
              <Heading1 theme={props.theme} variant="d5">
                まずは無料相談
              </Heading1>
            </Head>
            <Main>
              <Form {...form} css={styles.Form} beforeSubmit={beforeSubmit(title)} />
            </Main>
          </Root>
        )
      }}
    />
  )
}

const beforeSubmit = (title) => {
  return (values) => {
    window.dataLayer && window.dataLayer.push({
      event: 'app.conversion',
      eventCategory: title,
      eventAction: values.division,
      eventLabel: values.job
    })
  }
}

const Root = styled.div`
  color: ${props => props.theme.gray.contrast.c};
  padding: ${rem(64)} ${rem(20)};
`

const Head = styled.div``

const Heading1 = styled(Typography)`
  text-align: center;
`

const Main = styled.div`
  margin-top: ${rem(32)};
`

const styles = {
  Form: css`
    margin: ${rem(24)} auto 0;
    max-width: ${rem(layouts.defs.contentMaxWidth.small)};
    width: 100%;
  `
}

export default ThemeConsumer(Template)

export const query = graphql`
  query MainFormQuery {
    site {
      siteMetadata {
        siteUrl
        title
        description
        image
      }
    }
    forms: allContactFormYaml {
      edges {
        node {
          name
          inputFields {
            name
            label
            required
            type
            values {
              label
              value
            }
          }
          action
          endpoint
        }
      }
    }
  }
`
